module.exports = __webpack_public_path__ + "img/card-contract.15e585ab.svg";